import * as React from "react";
import { cn } from "../_internal/cn";
import type { TypeNarrativeAttributionProps } from "./NarrativeAttributionTypes";

/**
 * NarrativeAttribution — a narrative primitive that displays attribution
 * information for social media content, including an avatar, social network
 * icon, and user name.
 *
 * Styled via narrative-attribution.css (Seeds CSS custom properties);
 * consumers import the classes through @sproutsocial/racine/css/components.
 * Layout is horizontal with avatar, social icon, and user name arranged
 * side by side. Surface overrides are done with standard className / style.
 */
const NarrativeAttribution = React.forwardRef<
  HTMLDivElement,
  TypeNarrativeAttributionProps
>(
  (
    {
      avatarUrl,
      avatarAlt = "Profile avatar",
      userName,
      socialIcon,
      className,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn("seeds-narrative-attribution", className)}
        {...props}
      >
        <img
          src={avatarUrl}
          alt={avatarAlt}
          className="seeds-narrative-attribution-avatar"
        />
        <div className="seeds-narrative-attribution-social-icon">
          {socialIcon}
        </div>
        <span className="seeds-narrative-attribution-user-name">
          {userName}
        </span>
      </div>
    );
  }
);

NarrativeAttribution.displayName = "NarrativeAttribution";

export default NarrativeAttribution;
